'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _hasMoreMessages = require('conversations-schema/thread-history/operators/hasMoreMessages');

var _getMessageIsApproximatelyFromCurrentSession = require('conversations-schema/pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isEmailCapturePromptMessage');

var _isOfficeHoursMessage = require('conversations-schema/pubnub-message/operators/isOfficeHoursMessage');

var _isTypicalResponseTimeMessage = require('conversations-schema/pubnub-message/operators/isTypicalResponseTimeMessage');

var _VisitorThreadHistory = require('ui-addon-conversations/visitor-thread-history/components/VisitorThreadHistory');

var _VisitorThreadHistory2 = _interopRequireDefault(_VisitorThreadHistory);

var _TypingIndicator = require('ui-addon-conversations/components/TypingIndicator');

var _TypingIndicator2 = _interopRequireDefault(_TypingIndicator);

var _isIOS = require('../visitor-widget/util/isIOS');

var _InfiniteScroll = require('../util/InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _FadeSlideTransition = require('../transition/FadeSlideTransition');

var _FadeSlideTransition2 = _interopRequireDefault(_FadeSlideTransition);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatFeed = _react2.default.createClass({
  displayName: 'ChatFeed',

  propTypes: {
    assignedResponder: (0, _RecordPropType2.default)('Responder'),
    attachments: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
    channel: _react.PropTypes.string,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    companyName: _react.PropTypes.string,
    consentToCommunicateMessage: _react.PropTypes.string,
    currentConversation: (0, _RecordPropType2.default)('Conversation'),
    currentRole: _react.PropTypes.oneOf([_senderTypes.AGENT, _senderTypes.VISITOR]).isRequired,
    currentVisitor: (0, _RecordPropType2.default)('Visitor'),
    fetchNextHistory: _react.PropTypes.func,
    hasVisitorEmail: _react.PropTypes.bool,
    onAttachmentClick: _react.PropTypes.func.isRequired,
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    preview: _react.PropTypes.bool,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    requiresConsentToCommunicate: _react.PropTypes.bool,
    requiresExplicitConsentToProcess: _react.PropTypes.bool,
    responders: _react.PropTypes.instanceOf(_immutable.Map),
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
    sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
    systemOnline: _react.PropTypes.bool,
    threadHistory: (0, _RecordPropType2.default)('ThreadHistory'),
    typingResponder: (0, _RecordPropType2.default)('Responder'),
    userId: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      attachments: (0, _immutable.Map)(),
      systemOnline: true,
      sendVisitorEmailAddress: function sendVisitorEmailAddress() {
        return _q2.default.Promise.resolve();
      }
    };
  },
  componentDidMount: function componentDidMount() {
    var threadHistory = this.props.threadHistory;


    if (threadHistory && (0, _hasMessages.hasMessages)(threadHistory)) {
      this.scrollToBottomOfChatHistory();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _props = this.props,
        typingResponder = _props.typingResponder,
        threadHistory = _props.threadHistory;
    var prevThreadHistory = prevProps.threadHistory,
        prevTypingResponders = prevProps.typingResponder;


    if (!threadHistory) {
      return;
    }

    var chatHistoryUpdated = !prevThreadHistory && threadHistory || !(0, _immutable.is)((0, _getMessages.getMessages)(threadHistory).filter(_messageTypeComparators.isConversationalMessage).last(), (0, _getMessages.getMessages)(prevThreadHistory).filter(_messageTypeComparators.isConversationalMessage).last());

    var typingResponderUpdated = typingResponder !== prevTypingResponders;

    if (chatHistoryUpdated || typingResponderUpdated) {
      this.scrollToBottomOfChatHistory();
    }
  },
  fetchHistoryWithProps: function fetchHistoryWithProps() {
    var _props2 = this.props,
        systemOnline = _props2.systemOnline,
        fetchNextHistory = _props2.fetchNextHistory,
        preview = _props2.preview,
        currentConversation = _props2.currentConversation;


    if (preview || !systemOnline || !fetchNextHistory) {
      return;
    }

    fetchNextHistory(currentConversation);
  },
  fetchMore: function fetchMore() {
    var threadHistory = this.props.threadHistory;


    if (threadHistory && (0, _hasMoreMessages.hasMoreMessages)(threadHistory)) {
      this.fetchHistoryWithProps();
    }
  },
  scrollToBottomOfChatHistory: function scrollToBottomOfChatHistory() {
    var _this = this;

    requestAnimationFrame(function () {
      if (!_this.refs.scrollingChatHistory) {
        return;
      }

      _this.refs.scrollingChatHistory.scrollContainerToBottom();
    });
  },
  onAttachmentLoad: function onAttachmentLoad() {
    this.scrollToBottomOfChatHistory();
  },
  shouldRenderMessage: function shouldRenderMessage(message) {
    return (0, _messageTypeComparators.isConversationalMessage)(message) && (!(0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(message) && !(0, _isOfficeHoursMessage.isOfficeHoursMessage)(message) && !(0, _isTypicalResponseTimeMessage.isTypicalResponseTimeMessage)(message) || (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(message));
  },
  typingIndicatorIsFirstInGroup: function typingIndicatorIsFirstInGroup() {
    var lastMessage = (0, _getMessages.getMessages)(this.props.threadHistory).last();

    return (0, _pubnubMessageGetters.getSenderType)(lastMessage) === _senderTypes.SYSTEM || (0, _pubnubMessageGetters.getSenderType)(lastMessage) === _senderTypes.VISITOR;
  },
  renderFeed: function renderFeed() {
    var threadHistory = this.props.threadHistory;


    return _react2.default.createElement(_VisitorThreadHistory2.default, {
      assignedResponder: this.props.assignedResponder,
      attachments: this.props.attachments,
      channel: this.props.channel,
      chatHeadingConfig: this.props.chatHeadingConfig,
      coloring: this.props.coloring,
      companyName: this.props.companyName,
      consentToCommunicateMessage: this.props.consentToCommunicateMessage,
      currentRole: this.props.currentRole,
      currentVisitor: this.props.currentVisitor,
      hasVisitorEmail: this.props.hasVisitorEmail,
      onAttachmentClick: this.props.onAttachmentClick,
      onAttachmentLoad: this.onAttachmentLoad,
      potentialResponders: this.props.potentialResponders,
      predicate: this.shouldRenderMessage,
      publishMessage: this.props.publishMessage,
      republishMessage: this.props.republishMessage,
      requiresConsentToCommunicate: this.props.requiresConsentToCommunicate,
      requiresExplicitConsentToProcess: this.props.requiresExplicitConsentToProcess,
      responders: this.props.responders,
      sendFromResponders: this.props.sendFromResponders,
      sendVisitorEmailAddress: this.props.sendVisitorEmailAddress,
      systemOnline: this.props.systemOnline,
      threadHistory: threadHistory,
      typingResponder: this.props.typingResponder,
      userId: this.props.userId
    });
  },
  renderTypingIndicator: function renderTypingIndicator() {
    if (!this.props.typingResponder) {
      return null;
    }

    return _react2.default.createElement(_TypingIndicator2.default, {
      coloring: this.props.coloring,
      currentRole: _senderTypes.VISITOR,
      messageRole: _senderTypes.AGENT,
      isFirstInGroup: this.typingIndicatorIsFirstInGroup(),
      user: this.props.typingResponder
    });
  },
  render: function render() {
    var currentRole = this.props.currentRole;


    var className = (0, _classNames2.default)('messages-container flex-column add-flex-grow', {
      'p-x-10': currentRole === _senderTypes.AGENT,
      'p-x-6': currentRole !== _senderTypes.AGENT,
      'chat-feed-bottom': (0, _isIOS.isIOS)()
    });

    return _react2.default.createElement(
      _InfiniteScroll2.default,
      {
        className: 'messages-scroll-container',
        fetchMore: this.fetchMore,
        ref: 'scrollingChatHistory'
      },
      _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _FadeSlideTransition2.default,
          { appear: true, leave: false, direction: 'top' },
          this.renderFeed(),
          _react2.default.createElement(
            'div',
            null,
            this.renderTypingIndicator()
          )
        )
      )
    );
  }
});

exports.default = ChatFeed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatFeed.js
// module id = 1081
// module chunks = 2 3